<div #siSelectorMultiple id="si-selector-multiple-{{id}}" class="si-selector-multiple {{styleClass}}"
     [class.disabled]="disabled"
     [class.compact]="compact"
     [class.detail-mode]="detailMode"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)">
  <div *ngIf="!hideLabel">
    <si-label [text]="text"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
              forId="si-selector-multiple_dropdown-{{id}}"
    ></si-label>
  </div>
  <div class="si-selector-multiple_dropdown" siProvideParentForm>
    <p-multiSelect #pMultiSelect #formModel="ngModel"
                   inputId="si-selector-multiple_dropdown-{{id}}"
                   [options]="options"
                   [(ngModel)]="model"
                   [name]="name"
                   [placeholder]="disabled ? '' : placeholderTranslated"
                   [displaySelectedLabel]="displaySelectedLabel"
                   [maxSelectedLabels]="20"
                   [filter]="showDropdownSearch"
                   [showToggleAll]="showToggleAll"
                   [showHeader]="showDropdownSearch || showToggleAll"
                   [styleClass]="dropdownStyleClass"
                   [scrollHeight]="scrollHeight"
                   [autofocusFilter]="autofocusFilter"
                   [resetFilterOnHide]="resetFilterOnHide"
                   [disabled]="disabled"
                   (onChange)="onChangeMultiSelectModel($event)"
                   (onClick)="onClickMultiSelect()"
                   (onPanelHide)="onHideMultiSelect()"
                   siValidation="{{rule}}"
                   [siValidationElement]="validationElement"
                   [siValidationExternalErrorText]="validationExternalErrorText">
      <ng-template let-outerContext *ngIf="selectedItems" pTemplate="selectedItems">
        <ng-container *ngTemplateOutlet="selectedItems; context: {$implicit: outerContext}"></ng-container>
      </ng-template>
      <ng-template let-outerContext *ngIf="item" pTemplate="item">
        <ng-container *ngTemplateOutlet="item; context: {$implicit: outerContext}"></ng-container>
      </ng-template>
      <ng-template pTemplate="empty">
        <span *ngIf="optionsLoaded">{{'primeng.emptyMessage' | translate}}</span>
      </ng-template>
      <ng-template pTemplate="emptyfilter">
        <span *ngIf="optionsLoaded">{{'primeng.emptyFilterMessage' | translate}}</span>
      </ng-template>
    </p-multiSelect>
    <div #siSelectorMultipleLoader class="si-selector-multiple_dropdown_loader"><i class="icon-spinner"></i></div>
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="si-selector-multiple_dropdown_validation"
    ></si-validation-element>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
